/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from 'react';
import { Action } from '../ActionsCard/ActionCard';
import { TaskButton } from '../TaskButton/TaskButton';
import { useStyles } from './TaskList.styles';

type TaskListProps = {
    actions: Action[];
    onTaskClick: (index: number) => void;
};

export const TaskList: React.FC<TaskListProps> = ({ actions, onTaskClick }) => {
    const styles = useStyles();

    return (
        <div className={styles.taskList}>
            {actions.map((action, idx) => (
                <TaskButton
                    key={action.id}
                    checked={action.checked}
                    primaryContent={action.primaryContent}
                    secondaryContent={action.secondaryContent}
                    showSecondaryContent={action.showSecondaryContent}
                    onClick={() => onTaskClick(idx)}
                />
            ))}
        </div>
    );
};
